import IWall from 'components/interfaces/IWall';
import IWallMetaData from 'components/interfaces/IWallMetaData';
import store from 'store/store';

import getAmountOfGlassAreas from './getAmountOfGlassAreas';
import getDefaultDoorMetaData from './getDefaultDoorMetaData';
import getDefaultGlassAreaMetaData from './getDefaultGlassAreaMetaData';
import getDefaultWallMetaData from './getDefaultWallMetaData';
import getDoorsFromWallParts from './getDoorsFromWallParts';

const loadWallMetaData = (
  selectedWallIdentifier: string,
  wall: IWall,
  is3D: boolean
): IWallMetaData => {
  const state = store.getState();
  const { wallsMetaData } = state;

  const selectedWallMetaData = wallsMetaData.find(
    (metaData: IWallMetaData) => metaData.identifier === selectedWallIdentifier
  );

  const wallMetaData =
    selectedWallMetaData === undefined
      ? getDefaultWallMetaData(selectedWallIdentifier)
      : { ...selectedWallMetaData };

  if (!is3D) {
    return wallMetaData;
  }

  const doors = getDoorsFromWallParts(wall);

  const amountOfGlassAreas = getAmountOfGlassAreas(doors, wall);

  const glassAreasAmountInMetaData = wallMetaData.glassAreas.length;
  for (let i = glassAreasAmountInMetaData; i < amountOfGlassAreas; ++i) {
    wallMetaData.glassAreas.push(getDefaultGlassAreaMetaData());
  }

  wallMetaData.doors = doors.map((door) => {
    const existingDoorMetaData = wallMetaData.doors.find(
      (doorMetaData) => doorMetaData.doorId === door.doorID
    );

    if (existingDoorMetaData !== undefined) {
      return {
        ...existingDoorMetaData,
        doorTempId: door.id,
      };
    }

    return {
      ...getDefaultDoorMetaData(),
      doorId: door.doorID,
      doorTempId: door.id,
    };
  });

  return wallMetaData;
};

export default loadWallMetaData;
